import Service from '@/service/index.js';
export default {
  components: {
    Service
  },
  props: {
    projectAssetsResForms: {
      type: Array,
      default: {}
    },
    transferType: {
      type: Number,
      default: {}
    }
  },
  data() {
    return {
      massifTypeArr: null // 地块类型
    };
  },
  created() {
    // 获取用户类型 字典查询
    const obj = {
      MASSIF_TYPE: 'massifTypeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  }
};
